import { render, staticRenderFns } from "./AppDealHome.vue?vue&type=template&id=3fdfe06c&scoped=true"
import script from "./AppDealHome.vue?vue&type=script&lang=js"
export * from "./AppDealHome.vue?vue&type=script&lang=js"
import style0 from "./AppDealHome.vue?vue&type=style&index=0&id=3fdfe06c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdfe06c",
  null
  
)

export default component.exports